import React from 'react';

export default function PaginationToolbar({  children }) {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: 47,
      marginRight: 10,
      marginBottom: 2
    }}>
      {children}
    </div>
  );
}